import { VStack, Box } from "@chakra-ui/react";
import React from "react";
import { Large } from "../components/Type.js";
import { Question, QuestionWrapper } from "./Question.js";
import { questions } from "./id.questions.js";
import { t, msg } from "@lingui/macro";
import { useLingui } from "@lingui/react";


const Section = ({ category, questions }) => {
  const { _ } = useLingui();

  return (
    <Box w="100%">
      <Large>{_(category)}</Large>
      <QuestionWrapper>
        {questions.map(({ question, answer }) => {
          const Answer= () => {
            if (React.isValidElement(answer)){
              return answer
            }else{
              return _(answer)
            }
          }
          return <Question title={_(question)}><Answer/></Question>;
        })}
      </QuestionWrapper>
    </Box>
  );
};

export const FaqQuestions = () => {
  const { about, tip, cashout, personalData, etc } = questions;
  const { _ } = useLingui();

  return (
    <VStack>
      <Section category={_(msg`Tentang Saweria`)} questions={about} />
      <Section category={_(msg`Mengirimkan / Menerima Dukungan`)} questions={tip} />
      <Section category={_(msg`Mencairkan Dukungan`)} questions={cashout} />
      <Section category={_(msg`Pengaturan Data Diri`)} questions={personalData} />
      <Section category={_(msg`Biaya dan lain-lain`)} questions={etc} />
    </VStack>
  );
};
